import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdatePrivateProjectBankItemAsDeleted = async (
  projectId,
  privateItemId
) => {
  const apiPath = `project-bank/private/project/${projectId}/item/${privateItemId}/delete-item`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { privateItemId },
  });

  const response = await axios(signedRequest);

  return response.data;
};
